import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeEverLocationEditor = ({
  tradeId,
  initialEverLocation,
}: {
  tradeId: Trade['id'];
  initialEverLocation: string;
}) => {
  const [everLocation, setEverLocation] = useState(initialEverLocation);

  const updateEverLocationMutation = useMutation({
    onMutate: async ({ everLocation }: { everLocation: string }) => {
      tradesStore.updateTrade(tradeId, {
        ever_location: everLocation,
      });
    },
    mutationFn: async ({ everLocation }: { everLocation: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/ever_location`,
        // /api/trades/:trade_id/ever_location
        {
          ever_location: everLocation,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating ever location', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
    onSettled: () => {},
  });

  const handleEverLocationChange = useCallback(
    debounce((newEverLocation: string) => {
      updateEverLocationMutation.mutate({ everLocation: newEverLocation });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (everLocation === initialEverLocation) return;

    handleEverLocationChange(everLocation);
  }, [everLocation]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setEverLocation(e.target.value);
  }, []);

  useEffect(() => {
    setEverLocation(initialEverLocation);
  }, [initialEverLocation]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">
          Ever Location
        </div>
      </div>
      <InlineTextInput
        value={everLocation}
        onChange={onChange}
        placeholder="Enter Ever location"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeEverLocationEditor;
